"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.warning.name.required': '请至少提供一个头像名称以继续。',
};
